import React, {useEffect, useRef, useState} from 'react';
import { Content } from './styles';
import DatePicker, { registerLocale}  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from '../../hooks/Auth';
import toast from 'react-hot-toast';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import {api} from '../../services/api';
import { Simbol, Selo, RegraDia, Fertilidade} from '../Simbols/styles';
import CardAssinatura from '../CardAssinatura';
import { SquemaSimbols } from '../Simbols';

const sanitize = (text: string) => text.replace(/[<>&"\\`]/g, '');

const sensacoesLista = [
  { key: 2, label: 'MOLHADA' },
  { key: 4, label: 'ÚMIDA' },
  { key: 5, label: 'SECA' },
  { key: 6, label: 'PEGAJOSA' },
  { key: 7, label: 'ESCORREGADIA' },
  { key: 0, label: 'OUTRA' },
];

registerLocale('ptBR', ptBR);

interface iDataForms{
  data?: any;
  setShowmodal?: any;
  setUpdateciclo?: any;
  setUpdateTotalCiclos?: any;
}


export const AddDia: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  const { user } = useAuth();

  const [sensacao, setSensacao] = useState(2);
  const [descOutraSensacao, setDescOutraSensacao] = useState('');
  const [dia, setDia] = useState(data.diaini ? new Date(data.diaini) : new Date());
  const [id_user] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [obssensacao, setObs] = useState('');
  const [inifimciclo] = useState(data.inifimciclo? parseInt(data.inifimciclo) : null);
  const [numciclo] = useState(parseFloat(data.numciclo));
  const [addpadrao, setAddPadrao] = useState(0);
  const textarea = useRef(null);


  async function handleAddDia(){
    const diaStr = format(dia, "yyy-MM-dd");

    if (sensacao === 0 && descOutraSensacao.trim() === '') {
      toast.error('Preencha o campo para definir a sensação.');
      return;
    }

    const send = {
      id_user,
      'dia' : diaStr,
      sensacao,
      obssensacao,
      descoutrasensacao: sensacao === 0 ? descOutraSensacao : null,
      iduseredit,
      inifimciclo,
      numciclo,
      addpadrao
    }
    // console.log(send)
    try {
      await api.post('/ciclos/addDia.php', send);
      toast.success('ANOTAÇÃO ADICIONADA COM SUCESSO');
      if(inifimciclo === 1){
        setTimeout(function(){
          window.location.reload();
      }, 500)
        
      } else {
        setUpdateciclo(true);
      }
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ADICIONAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          locale="ptBR"
          selected={dia}
          onChange={(date: Date) => setDia(date)}
          className="datepick"
          maxDate={new Date()}
          disabled={data.diafim ? true : false}
          excludeDates={data.excludedates}            
        />
        <fieldset>
          <legend>O que você sente?</legend>
          <div className="grid3f">
            {sensacoesLista.map((s, i) => (
              <button key={i} className={`${sensacao === s.key ? 'checked' : ''}`} onClick={() => setSensacao(s.key)}>{s.label}</button>
            ))}
          </div>
          <div style={{ overflow: 'hidden', maxHeight: sensacao === 0 ? '70px' : '0', transition: 'max-height 0.3s ease', marginBottom: sensacao === 0 ? '4px' : '0' }}>
            <input
              style={{ width: '100%', padding: '8px', borderRadius: 5, border: '1px solid rgba(0,0,0,0.4)' }}
              onChange={(e) => setDescOutraSensacao(sanitize(e.currentTarget.value))}
              value={descOutraSensacao}
              maxLength={35}
              placeholder="Informe outra sensação"
            />
          </div>
        </fieldset>

        <fieldset>
          <legend>O que você vê?</legend>
          <textarea style={{ marginBottom: 5}} ref={textarea} onChange={(e) => setObs(sanitize(e.currentTarget.value))} value={obssensacao} maxLength={150} rows={3} placeholder="Se desejar, informe o que você vê ou uma observação."></textarea>
        </fieldset>

        <div className="flex">
            <div className="flex">
            {/*
            <input type="checkbox" id="addpadrao" name="addpadrao" value={addpadrao} onClick={() => setAddPadrao(addpadrao === 1 ? 0 : 1)} />
            <small> add padrão da regra</small>
            */}
            </div>
            <button className="add" onClick={handleAddDia}>adicionar</button>
        </div>
      </Content>
  );
}

export const Edit: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  const { user } = useAuth();

  const [sensacao, setSensacao] = useState(parseInt(data.sensacao));
  const [descOutraSensacao, setDescOutraSensacao] = useState(data.descoutrasensacao || '');
  const [id_user] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [obssensacao, setObs] = useState(data.obssensacao);
  const [numciclo] = useState(parseFloat(data.numciclo));
  const textarea = useRef(null);


  async function handleChangeDia(){

    const send = {
      "id_mob": parseFloat(data.id_mob),
      id_user,
      'dia' : data.dia,
      sensacao,
      obssensacao,
      descoutrasensacao: sensacao === 0 ? descOutraSensacao : null,
      iduseredit,
      'inifimciclo': data.inifimciclo,
      numciclo,
      "regra": parseFloat(data.regra),
      "regracount": parseFloat(data.regracount) || null,
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)
    }
    // console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }

  async function handleDelDia(){    
    const send = {
      "id_mob": parseFloat(data.id_mob),
      id_user,
      iduseredit
    }
    
    try {
      await api.post('/ciclos/delDia.php', send);
      toast.success('ANOTAÇÃO DELETADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR APAGAR';
      toast.error(resp);
    }

  }

  function confirmDel(){
    confirmAlert({
      title: 'Confirme',
      message: 'Tem certeza que deseja pagar? esta ação não poderá ser desfeita.',
      buttons: [
        {
          label: 'SIM',
          onClick: () => handleDelDia()
        },
        {
          label: 'Não',
          onClick: () => {}
        }
      ]
    });
  }

  return (
      <Content>
        <fieldset>
          <legend>O que você sente?</legend>
          <div className="grid3f">
            {sensacoesLista.map((s, i) => (
              <button key={i} className={`${sensacao === s.key ? 'checked' : ''}`} onClick={() => setSensacao(s.key)}>{s.label}</button>
            ))}
          </div>
          <div style={{ overflow: 'hidden', maxHeight: sensacao === 0 ? '70px' : '0', transition: 'max-height 0.3s ease', marginBottom: sensacao === 0 ? '4px' : '0' }}>
            <input
              style={{ width: '100%', padding: '8px', borderRadius: 5, border: '1px solid rgba(0,0,0,0.4)' }}
              onChange={(e) => setDescOutraSensacao(sanitize(e.currentTarget.value))}
              value={descOutraSensacao}
              maxLength={35}
              placeholder="Informe outra sensação"
            />
          </div>
        </fieldset>

        <fieldset>
          <legend>O que você vê?</legend>
          <textarea style={{marginBottom: 5}} ref={textarea} onChange={(e) => setObs(sanitize(e.currentTarget.value))} value={obssensacao} maxLength={150} rows={3} placeholder="Se desejar, informe o que você vê ou uma observação."></textarea>
        </fieldset>

        <div className="flex">
            <button className="del" onClick={confirmDel}>Deletar</button>
            <button className="add" onClick={handleChangeDia}>atualizar</button>
        </div>
      </Content>
  );
}

export const EditSimb: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
  const { user } = useAuth();
  const [regra, setRegra] = useState(parseFloat(data.regra));

  async function handleChangeDia(e:number){ 
    setRegra(e);  
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": e,
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)  
    }
    
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid3">
            <button className={`${regra === 1 && 'checked'}`} onClick={() => handleChangeDia(1)}><Simbol><div className={"regra1"}></div></Simbol></button>
            <button className={`${regra === 2 && 'checked'}`} onClick={() => handleChangeDia(2)}><Simbol><div className={"regra2"}></div></Simbol></button>
            <button className={`${regra === 3 && 'checked'}`} onClick={() => handleChangeDia(3)}><Simbol><div className={"regra3"}></div></Simbol></button>
            <button className={`${regra === 4 && 'checked'}`} onClick={() => handleChangeDia(4)}><Simbol><div className={"regra4"}></div></Simbol></button>
            <button className={`${regra === 5 && 'checked'}`} onClick={() => handleChangeDia(5)}><Simbol><div className={"regra5"}></div></Simbol></button>
            <button className={`${regra === 6 && 'checked'}`} onClick={() => handleChangeDia(6)}><Simbol><div className={"regra6"}></div></Simbol></button>
            <button className={`${regra === 7 && 'checked'}`} onClick={() => handleChangeDia(7)}><Simbol><div className={"regra7"}></div></Simbol></button>
            <button className={`${regra === 8 && 'checked'}`} onClick={() => handleChangeDia(8)}><Simbol><div className={"regra8"}></div></Simbol></button>
            <button className={`${regra === 9 && 'checked'}`} onClick={() => handleChangeDia(9)}><Simbol><div className={"regra9"}></div></Simbol></button>
        </div>
      </Content>
  );
}

export const EditSelo: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  
  const { user } = useAuth();
  const [selo, setSelo] = useState(parseFloat(data.selo));

  async function handleChangeDia(e:number){ 
    setSelo(e);  
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": parseFloat(data.regra),
      "fertilidade": parseFloat(data.fertilidade),
      "selo": e,
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)  
    }
    // console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid4auto">
            <button className={`${selo === 1 && 'checked'}`} onClick={() => handleChangeDia(1)}><Selo><div className={"regra1"}></div></Selo></button>
            <button className={`${selo === 2 && 'checked'}`} onClick={() => handleChangeDia(2)}><Selo><div className={"regra2"}></div></Selo></button>
            <button className={`${selo === 3 && 'checked'}`} onClick={() => handleChangeDia(3)}><Selo><div className={"regra3"}></div></Selo></button>
            <button className={`${selo === 4 && 'checked'}`} onClick={() => handleChangeDia(4)}><Selo><div className={"regra4"}></div></Selo></button>
        </div>
      </Content>
  );
}

export const ChangePositionCiclo: React.FC<iDataForms> = ({ data }) => {

  
  const { user } = useAuth();
  const [selectciclos, setSelectciclos] = useState(data.numciclo);
  
  async function handleChangePositionCiclo(){ 

    const send = {      
      "id_user": parseInt(data.id_user),
      "iduseredit": parseInt(user.iduser),      
      "numciclo": parseFloat(data.numciclo),
      "selectciclos" : selectciclos
    }
  
    // console.log(send)
    try {
      await api.post('/ciclos/chageCicloPosition.php', send);
      toast.success('SUCESSO, AGUARDE');
      setTimeout(function(){
        window.location.reload();
      }, 700);
      
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
    
  }

  return (
      <Content>  
        <div className="grid4auto">
        {data.allciclos.map((e:any, i:number) => (
          i === 0 ? (
            <button key={i} className={`${selectciclos === e.numciclo && 'checked'}`} onClick={() => setSelectciclos(e.numciclo)}>Ciclo Atual</button>  
          ) : (
            <button key={i} className={`${selectciclos === e.numciclo && 'checked'}`} onClick={() => setSelectciclos(e.numciclo)}>{data.allciclos.length - i}º Ciclo</button>
          )
        ))}        
        </div>    
        <div className="flex">
            <div></div>
            <button className="add" onClick={() => handleChangePositionCiclo()}>Mudar posição</button>
        </div>
        
      </Content>
  );
}

export const Assine: React.FC<iDataForms> = () => {
  
  return (
    <CardAssinatura />
  );
}

export const AddRegra: React.FC<iDataForms> = ({ data, setShowmodal }) => {

  const { user } = useAuth();

  const [iduser] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [instrucao, setInstrucao] = useState('');  
  const textarea = useRef(null);


  async function handleAddregra(){
    const send = {
      iduser,
      iduseredit,
      instrucao,
      lido: 0
    }
    // console.log(send)
    try {
      await api.post('/regras/addRegra.php', send);
      toast.success('REGRA ADICIONADA COM SUCESSO');
      setShowmodal(false);

      setTimeout(function(){
          window.location.reload();
      }, 500);
       
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ADICIONAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        
        <div>
            <textarea ref={textarea} onChange={(textarea) => setInstrucao(textarea.currentTarget.value)} value={instrucao} maxLength={500} rows={5} placeholder="Digite a mensagem, aviso e novas instruções ao usuário"></textarea>
        </div>

        <div className="flex">
            <span></span>            
            <button className="add" onClick={handleAddregra}>adicionar</button>
        </div>
      </Content>
  );
}

export const EditRegra: React.FC<iDataForms> = ({ data, setShowmodal }) => {

  const { user } = useAuth();
  // console.log(data)
  const [iduser] = useState(parseInt(data.dados.iduser));
  const [idregra] = useState(parseInt(data.dados.idregra));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [instrucao, setInstrucao] = useState(data.dados.instrucao);  
  const textarea = useRef(null);


  async function handleEditregra(){
    const send = {
      iduser,
      idregra,
      iduseredit,
      instrucao
    }
    // console.log(send)
    try {
      await api.post('/regras/editRegra.php', send);
      toast.success('REGRA MODIFICADA COM SUCESSO');
      setShowmodal(false);

      setTimeout(function(){
          window.location.reload();
      }, 500);
       
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR MODIFICAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        
        <div>
            <textarea ref={textarea} onChange={(textarea) => setInstrucao(textarea.currentTarget.value)} value={instrucao} maxLength={500} rows={5} placeholder="Digite a mensagem, aviso e novas instruções ao usuário"></textarea>
        </div>

        <div className="flex">
            <span></span>            
            <button className="add" onClick={handleEditregra}>SALVAR</button>
        </div>
      </Content>
  );
}

export const EditSimbCor: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
  const { user } = useAuth();
  const [regra, setRegra] = useState(parseFloat(data.regra));
  const [selo, setSelo] = useState(parseFloat(data.selo));
  
  async function handleChangeDia(){ 
    
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": regra > 0 ? regra : 0,
      "regracount": parseFloat(data.regracount) || null,
      "fertilidade": parseFloat(data.fertilidade),
      "selo": selo,
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)
    }
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }

  

  function handleChangeBoth(){
    let r = regra > 0 ? regra : 0;
    let s = selo > 0 ? selo : 0;
    if(r === 0 && s === 0){
      toast.error('ESCOLHA PELO MENOS 1 SÍMBOLO OU 1 COR');
      return;
    } else {

        if(regra !== parseFloat(data.regra) || selo !== parseFloat(data.selo)){
          handleChangeDia();
        }

    }
  }

  return (
      <Content>
        <fieldset>        
          <legend>Escolha o Símbolo</legend>
          <div className="grid3">
              <button className={`${regra === 1 && 'checked'}`} onClick={() => setRegra(1)}><Simbol><div className={"regra1"}></div></Simbol></button>
              <button className={`${regra === 2 && 'checked'}`} onClick={() => setRegra(2)}><Simbol><div className={"regra2"}></div></Simbol></button>
              <button className={`${regra === 3 && 'checked'}`} onClick={() => setRegra(3)}><Simbol><div className={"regra3"}></div></Simbol></button>
              <button className={`${regra === 4 && 'checked'}`} onClick={() => setRegra(4)}><Simbol><div className={"regra4"}></div></Simbol></button>
              <button className={`${regra === 5 && 'checked'}`} onClick={() => setRegra(5)}><Simbol><div className={"regra5"}></div></Simbol></button>
              <button className={`${regra === 6 && 'checked'}`} onClick={() => setRegra(6)}><Simbol><div className={"regra6"}></div></Simbol></button>
          </div>
          <div className="grid3to4">
              <button className={`${regra === 7 && 'checked'}`} onClick={() => setRegra(7)}><Simbol><div className={"regra7"}></div></Simbol></button>
              <button className={`${regra === 8 && 'checked'}`} onClick={() => setRegra(8)}><Simbol><div className={"regra8"}></div></Simbol></button>
              <button className={`${regra === 9 && 'checked'}`} onClick={() => setRegra(9)}><Simbol><div className={"regra9"}></div></Simbol></button>
              <button className={`${regra === 0 && 'checked'}`} onClick={() => setRegra(0)}><div className='semDefinicao'></div></button>
          </div>
        </fieldset>
        <fieldset>
          <legend>Escolha a cor</legend>
          <div className="grid5auto">
              <button className={`${selo === 1 && 'checked'}`} onClick={() => setSelo(1)}><Selo><div className={"regra1"}></div></Selo></button>
              <button className={`${selo === 2 && 'checked'}`} onClick={() => setSelo(2)}><Selo><div className={"regra2"}></div></Selo></button>
              <button className={`${selo === 3 && 'checked'}`} onClick={() => setSelo(3)}><Selo><div className={"regra3"}></div></Selo></button>
              <button className={`${selo === 4 && 'checked'}`} onClick={() => setSelo(4)}><Selo><div className={"regra4"}></div></Selo></button>
              <button className={`${(selo === null) || (selo === 0) ? 'checked' : 'false'}`} onClick={() => setSelo(0)}><div className='semDefinicao'></div></button>
          </div>
        </fieldset> 
        <div className="flex">
          <small>Escolha pelo menos<br/>um símbolo ou uma cor</small>
          <button onClick={handleChangeBoth} className="add">ATUALIZAR</button>
        </div>
      </Content>
  );
}


export const EditRegraDia: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
 
  const { user } = useAuth();
  const [regradia, setRegraDia] = useState(parseFloat(data.regradia));

  async function handleChangeDia(){     
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": parseFloat(data.regra),
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": regradia,
      "descoutrasensacao": data.descoutrasensacao || null,
    }
    // console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid4auto noPaddingButton">
            <button className={`${regradia === 1 && 'checked'}`} onClick={() => setRegraDia(1)}><RegraDia><div style={{height: '30px'}} className={"regra1"}></div></RegraDia></button>
            <button className={`${regradia === 2 && 'checked'}`} onClick={() => setRegraDia(2)}><RegraDia><div style={{height: '30px'}} className={"regra2"}></div></RegraDia></button>
            <button className={`${regradia === 3 && 'checked'}`} onClick={() => setRegraDia(3)}><RegraDia><div style={{height: '30px'}} className={"regra3"}></div></RegraDia></button>
            <button className={`${regradia === 4 && 'checked'}`} onClick={() => setRegraDia(4)}><RegraDia><div style={{height: '30px'}} className={"regra4"}></div></RegraDia></button>
        </div>

        {regradia === 1 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 1:</strong><br/>
          Evitar relação sexual nos dias de forte sangramento durante a menstruação.
        </fieldset>
        }

        {regradia === 2 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 2:</strong><br/>
          Noites alternadas estão disponíveis para relação sexual, quando estes dias foram reconhecidos como inférteis - Padrão Básico de Infertilidade (PBI).
        </fieldset>
        }

        {regradia === 3 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 3:</strong><br/>
          Evitar relação sexual em qualquer dia de fluxo ou sangramento que interrompa o PBI. Se não evoluir até o Ápice e retornar ao PBI, espere 3 dias antes de reiniciar as relações sexuais.  Continuar aplicando a Regra 2.
        </fieldset>
        }

        {regradia === 4 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA DO ÁPICE:</strong><br/>
          A partir da manhã do quarto dia após o Ápice até o final do ciclo, as relações sexuais estão liberadas todos os dias a qualquer hora.
        </fieldset>
        }

        <div className="flex">
          <small>Escolha a regra<br/>para este dia</small>
          <button onClick={handleChangeDia} className="add">Atualizar</button>
        </div>
      </Content>
  );
}


export const EditAllSimbs: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
  const { user } = useAuth();
  const regraFertilidadeSimb = parseFloat(data.regra) === 5 ? 5 : 0;
  const [regra, setRegra] = useState(parseFloat(data.regra) <= 4 ? parseFloat(data.regra) : 0);
  const [regracount, setRegracount] = useState(parseFloat(data.regracount) || 0);
  const [fertilidade, setFertilidade] = useState(parseFloat(data.fertilidade) || regraFertilidadeSimb || 0);
  const [relacao, setRelacao] = useState(parseFloat(data.relacao) || 0);
  const [selo, setSelo] = useState(parseFloat(data.selo) || 0);
  const [loadingSave, setLoadingSave] = useState(false);

  type ListItem = { key: number; cls?: string; label?: string; comp?: string };

  const regraLista: ListItem[] = [
    { key: 1, cls: 'regra1' },
    { key: 2, cls: 'regra2' },
    { key: 3, cls: 'regra3' },
    { key: 4, cls: 'regra4' },
    { key: 0, label: 'NÃO MOSTRAR' },
  ];

  const regracountLista: ListItem[] = [
    { key: 6, cls: 'regra6' },
    { key: 7, cls: 'regra7' },
    { key: 8, cls: 'regra8' },
    { key: 9, cls: 'regra9' },
    { key: 0, label: 'NÃO MOSTRAR' },
  ];

  const seloLista: ListItem[] = [
    { key: 1, cls: 'regra1' },
    { key: 2, cls: 'regra2' },
    { key: 3, cls: 'regra3' },
    { key: 4, cls: 'regra4' },
    { key: 0, label: 'NÃO MOSTRAR' },
  ];

  const fertilLista: ListItem[] = [
    { key: 5, comp: 'simbol', cls: 'regra5' },
    { key: 11, comp: 'fertilidade', cls: 'regra11' },
    { key: 0, label: 'NÃO MOSTRAR' },
  ];

  // Garante combinações válidas de regra + selo ao mudar qualquer um dos dois
  useEffect(() => {
    switch (regra) {
      case 1: // bola cheia → apenas vermelho
        if (selo !== 0 && selo !== 1) setSelo(1);
        if (fertilidade > 0) setFertilidade(0);
        if (regracount !== 0) setRegracount(0);
        break;
      /*
      case 2: // pontinhos → não aceita amarelo/verde; com fertilidade ativa → rosa
        if (selo === 2 || selo === 3) setSelo(0);
        else if ((fertilidade === 5 || fertilidade === 11) && selo !== 4 && selo !== 0) setSelo(4);
        break;
      */
      case 3: // = → apenas amarelo
        if (selo !== 2 && selo !== 0) setSelo(0);
        break;
      case 4: // | → apenas verde
        if (selo !== 3 && selo !== 0) setSelo(3);
        break;
      case 6: // x → apenas rosa
        if (selo !== 4 && selo !== 0) setSelo(4);
        break;
      case 7: case 8: case 9: // números → qualquer cor exceto vermelho
        if (selo === 1) setSelo(0);
        break;
    }
  }, [regra, selo]);

  // Garante que fertilidade ativa não coexiste com vermelho (exceto regra 1 e 6)
  useEffect(() => {
    if (regra === 1) { setFertilidade(0); return; }
    if (regra !== 6 && (fertilidade === 5 || fertilidade === 11) && selo === 1) {
      setSelo(0);
    }
  }, [fertilidade]);

  const regrasXselos: { [key: number]: number[] } = {
    1: [0, 1],
    //2: [0, 1, 4],
    3: [0, 2],
    4: [0, 3],
    6: [0, 2, 3, 4],
    7: [0, 2, 3, 4],
    8: [0, 2, 3, 4],
    9: [0, 2, 3, 4],
  };

  function isSeloDisabled(r: number, seloKey: number): boolean {
    const allowed = regrasXselos[r];
    if (!allowed) return false;
    return !allowed.includes(seloKey);
  }

  async function handleChangeDia() {
    setLoadingSave(true);
    const send = {
      ...data,
      iduseredit: parseInt(user.iduser),
      regra: regra || null,
      regracount: regracount || null,
      fertilidade: fertilidade || null,
      selo: selo || null,
      relacao: relacao || null,
    };
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      toast.error(err.response?.statusText || 'ERRO AO TENTAR ATUALIZAR');
    }
    setLoadingSave(false);
  }

  function handleChangeBoth() {
    const r = regra > 0 ? regra : 0;
    const s = selo > 0 ? selo : 0;
    const f = fertilidade > 0 ? fertilidade : 0;
    const rel = relacao > 0 ? relacao : 0;
    const rc = regracount > 0 ? regracount : 0;
    if (r === 0 && s === 0 && f === 0 && rel === 0 && rc === 0) {
      toast.error('ESCOLHA PELO MENOS UM SÍMBOLO OU UMA COR');
      return;
    }
    if (
      regra !== (parseFloat(data.regra) || 0) ||
      selo !== (parseFloat(data.selo) || 0) ||
      fertilidade !== (parseFloat(data.fertilidade) || regraFertilidadeSimb || 0) ||
      relacao !== (parseFloat(data.relacao) || 0) ||
      regracount !== (parseFloat(data.regracount) || 0)
    ) {
      handleChangeDia();
    }
  }

  return (
    <Content>
      <fieldset>
        <legend>Escolha o Símbolo</legend>
        <div className="grid5auto">
          {regraLista.map((e, i) => (
            <button key={i} style={{minHeight: 35}} className={regra === e.key ? 'checked' : ''} onClick={() => setRegra(e.key)}>
              {e.cls ? <Simbol><div className={e.cls}></div></Simbol> : <small>{e.label}</small>}
            </button>
          ))}
        </div>
        <div className="grid5auto" style={{ marginTop: -8 }}>
          {regracountLista.map((e, i) => (
            <button key={i} style={{minHeight: 35}} className={regracount === e.key ? 'checked' : ''} onClick={() => setRegracount(e.key)}>
              {e.cls ? <Simbol><div className={e.cls}></div></Simbol> : <small>{e.label}</small>}
            </button>
          ))}
        </div>
      </fieldset>

      <fieldset>
        <legend>Escolha a cor</legend>
        <div className="grid5auto">
          {seloLista.map((e, i) => {
            const disabled = isSeloDisabled(regra, e.key);
            return (
              <button
                key={i}
                className={selo === e.key ? 'checked' : ''}
                onClick={() => !disabled && setSelo(e.key)}
                style={{ opacity: disabled ? 0.15 : 1, minHeight: 35}}
              >
                {e.cls ? <Selo><div className={`cor ${e.cls}`}></div></Selo> : <small>{e.label}</small>}
              </button>
            );
          })}
        </div>
      </fieldset>

      <div style={{ display: 'flex', gap: 6 }}>
        <fieldset style={{width: '60%' }}>
          <legend>Fertilidade</legend>
          <div className="grid3">
            {fertilLista.map((e, i) => (
              <button key={i} style={{minHeight: 35}} className={fertilidade === e.key ? 'checked' : ''} onClick={() => setFertilidade(e.key)}>
                {e.comp === 'simbol' ? <Simbol><div className={e.cls}></div></Simbol>
                  : e.comp === 'fertilidade' ? <Fertilidade><div className={e.cls}></div></Fertilidade>
                  : <small>{e.label}</small>}
              </button>
            ))}
          </div>
        </fieldset>

        <fieldset style={{width: '40%' }}>
          <legend>Relação</legend>
          <div className="grid2">
            <button className={relacao === 1 ? 'checked' : ''} onClick={() => setRelacao(1)}>
              <strong style={{ fontSize: '0.85rem' }}>R</strong>
            </button>
            <button className={relacao === 0 ? 'checked' : ''} onClick={() => setRelacao(0)}>
              <small>NÃO MOSTRAR</small>
            </button>
          </div>
        </fieldset>
      </div>

      <div className="flex">
        <div className="flex">
          <div style={{ marginRight: 8, alignItems: 'center', display: 'flex', justifyContent: 'center', width: 40, height: 47 }}>
            <SquemaSimbols
              regra={regra}
              selo={selo}
              fertilidade={fertilidade}
              regracount={regracount}
              relacao={relacao} edit={false} 
              click={() => {}} 
            />
          </div>    
          <small>Escolha pelo menos<br />um símbolo ou uma cor</small>
        </div>
        <button onClick={handleChangeBoth} className="add" disabled={loadingSave}>
          {loadingSave ? '...' : 'ATUALIZAR'}
        </button>
      </div>
    </Content>
  );
}
